
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(574|754|822|93)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
